import { combineReducers } from "redux";
import * as surveyReducers from './survey/survey.reducers';
import * as languageReducers from './language/language.reducer';
import * as authReducers from './auth/auth.reducer';
import * as attemptSurveyReducers from './attemptSurvey/attemptSurvey.reducer';

export const rootReducer = combineReducers({
    [surveyReducers.surveyFeatureKey]: surveyReducers.reducer,
    [languageReducers.languageFeatureKey]: languageReducers.reducer,
    [authReducers.authFeatureKey]: authReducers.reducer,
    [attemptSurveyReducers.attemptSurveyFeatureKey]: attemptSurveyReducers.reducer
});